var _path, _path2, _path3, _circle, _path4, _path5, _path6, _circle2, _path7, _circle3, _path8, _circle4, _path9, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#39c2d8",
    d: "M69 82H31c-7.18 0-13-5.82-13-13V31c0-7.18 5.82-13 13-13h38c7.18 0 13 5.82 13 13v38c0 7.18-5.82 13-13 13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M30 17c-7.168 0-13 5.832-13 13v39c0 7.168 5.832 13 13 13h39c7.168 0 13-5.832 13-13V30c0-7.168-5.832-13-13-13H30zm0 2h39c6.065 0 11 4.935 11 11v39c0 6.065-4.935 11-11 11H30c-6.065 0-11-4.935-11-11V30c0-6.065 4.935-11 11-11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M32.838 22C26.862 22 22 26.862 22 32.838v33.326C22 72.14 26.862 77 32.838 77h33.324C72.138 77 77 72.139 77 66.164V47.502a.5.5 0 0 0-1 0v18.662C76 71.588 71.586 76 66.162 76H32.838C27.414 76 23 71.588 23 66.164V32.838C23 27.414 27.414 23 32.838 23H66.5a.5.5 0 0 0 0-1H32.838zM76.5 37.002a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 65,
    r: 4.5,
    fill: "#565fa1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M57 70c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm0-9c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fefdef",
    d: "M34.489 48.523c0-9.382 7.606-16.989 16.989-16.989s16.989 7.606 16.989 16.989-7.606 16.989-16.989 16.989-16.989 0-21.42-9.602c4.431-.74 4.431-2.217 4.431-7.387z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M51.477 66.012c-9.287 0-17.308 0-21.875-9.893a.5.5 0 0 1 .372-.703c4.014-.669 4.014-1.741 4.014-6.894 0-9.644 7.845-17.488 17.488-17.488 9.644 0 17.489 7.845 17.489 17.488s-7.844 17.49-17.488 17.49zm-20.688-9.731c4.333 8.731 11.573 8.73 20.688 8.73 9.092 0 16.489-7.397 16.489-16.489s-7.397-16.488-16.489-16.488-16.488 7.396-16.488 16.488c0 4.906-.001 6.885-4.2 7.759z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 65,
    r: 4.5,
    fill: "#565fa1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M42 70c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm0-9c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 45,
    r: 1.5,
    fill: "#565fa1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M60 47c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 45,
    r: 1.5,
    fill: "#565fa1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M48 47c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M53.5 57a8.045 8.045 0 0 1-7.221-4.553.5.5 0 0 1 .902-.432A7.038 7.038 0 0 0 53.5 56a7.033 7.033 0 0 0 6.331-4.011.5.5 0 1 1 .904.428A8.039 8.039 0 0 1 53.5 57z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaze);
export default __webpack_public_path__ + "static/media/waze.3d9d4eebebaafe9f81ef1988b4be0bf7.svg";
export { ForwardRef as ReactComponent };